import { useMutation, useQuery } from "@apollo/client";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { SET_ONLINE_STATUS } from "../../../../queries/mutation/broadcaster/mutation";
import { GET_ONLINE_STATUS } from "../../../../queries/mutation/broadcaster/queries";
import Loading from "../../../Loading";
import DashCard from "../DashCard";

const OnlineStatusUpdate = () => {
  const {
    loading,
    error,
    data: onlineData,
    refetch,
  } = useQuery(GET_ONLINE_STATUS, { fetchPolicy: "no-cache" });
  const [isOnline, setIsOnline] = useState(false);

  const [updateOnlineStatus, { loading: updateLoading }] =
    useMutation(SET_ONLINE_STATUS);
  useEffect(() => {
    if (onlineData) {
      setIsOnline(onlineData.getOnlineStatus);
    }
  }, [onlineData]);
  if (onlineData === undefined) {
    return <Loading />;
  }

  const updateStatus = async () => {
    const { data: responseData } = await updateOnlineStatus({
      variables: {
        onlineStatus: !isOnline,
      },
    });
    if (responseData) {
      await refetch();
      toast.success("Successfully updated Online Status");
    }
  };

  return (
    <DashCard
      title="Online status"
      aside={
        <span
          className={`badge ${isOnline ? "badge-success" : "badge-error"} badge-outline`}
        >
          {isOnline ? "Online" : "Offline"}
        </span>
      }
    >
      <p className="text-sm text-base-content/60">
        {isOnline
          ? "Offline tips are paused while you're live; subscription renewals wait too."
          : "Offline tips and subscription renewals go through."}
      </p>
      <button
        className={`btn btn-sm w-full ${isOnline ? "btn-error btn-outline" : "btn-success"}`}
        disabled={loading || updateLoading}
        onClick={() => updateStatus()}
      >
        {loading || updateLoading ? (
          <div className="loading loading-spinner loading-sm" />
        ) : isOnline ? (
          "Go offline"
        ) : (
          "Go online"
        )}
      </button>
    </DashCard>
  );
};

export default OnlineStatusUpdate;
